import {
  QUERY_PROMISSORIES,
  OPEN_QUERY_PROMISSORY_MODAL,
  CLOSE_QUERY_PROMISSORY_MODAL,
  RESET_QUERY_DATA,
  SET_AVAILABLE_QUOTA
} from '../constants/query_promissory_constants';
import { sendRequest, completeRequest, errorOnRequest } from './request_state';
import RequestService from '../services/request_service';
import queryPromissoryFiltersSanitizer from '../helpers/sanitizers/queryPromissoryFilters';
import { newAlert, serverStatusError } from './alert_actions';
import _get from 'lodash/get';

const requestServiceNode = new RequestService('node');

export const openQueryPromissoryModal = () => {
  return dispatch => {
    dispatch({
      type: OPEN_QUERY_PROMISSORY_MODAL
    });
  };
};

export const closeQueryPromissoryModal = () => {
  return dispatch => {
    dispatch(errorOnRequest('QueryPromissories', null));
    dispatch({
      type: CLOSE_QUERY_PROMISSORY_MODAL
    });
  };
};

export const setAvailableQuota = availableQuota => {
  return dispatch => {
    dispatch({
      type: SET_AVAILABLE_QUOTA,
      availableQuota
    });
  };
};

export const resetQueryData = () => {
  return dispatch => {
    dispatch({
      type: RESET_QUERY_DATA
    });
  };
};

function setPromissories(data) {
  return {
    type: QUERY_PROMISSORIES,
    data
  };
}

export const queryUniquePromissory = (params = {}) => async dispatch => {
  dispatch(sendRequest('QueryPromissories'));
  try {
    const payload = await requestServiceNode.get(
      'promissories/query',
      queryPromissoryFiltersSanitizer(params)
    );

    dispatch(setPromissories(payload.data));
    dispatch(errorOnRequest('QueryPromissories', null));
  } catch (errors) {
    const err = await errors.json();
    dispatch(errorOnRequest('QueryPromissories', err));
    dispatch(setPromissories([]));

    if (err.errors) {
      dispatch(newAlert('error', 'ERROR:', err.errors.base));
    } else {
      dispatch(
        newAlert(
          'error',
          'ERROR:',
          'Hubo un error procesando su solicitud, por favor comuníquese con sistemas.'
        )
      );
    }
  } finally {
    dispatch(completeRequest('QueryPromissories'));
  }
};

export const fetchAvailableQuota = contract => async dispatch => {
  dispatch(sendRequest('QueryPromissoryAvailableQuota'));
  try {
    const payload = await requestServiceNode.get(
      `contracts/contractInfo/${contract}`
    );
    dispatch(setAvailableQuota(payload.data.availableQuota));
  } catch (errors) {
    dispatch(serverStatusError(errors));
    _get(errors, 'errors.base[0]') &&
      dispatch(newAlert('error', 'ERROR:', errors.errors.base[0]));
  } finally {
    dispatch(completeRequest('QueryPromissoryAvailableQuota'));
  }
};
